import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import DropdownMenu from '@cobliteam/ui/components/DropdownMenu';
import Icon from '@cobliteam/ui/icons';
import type { ReactNode } from 'react';

export interface DataTableExportProps {
  children: ReactNode;
  exporting?: boolean;
  defaultOpen?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const DataTableExport = ({ children, exporting = false, defaultOpen = false, open, onOpenChange }: DataTableExportProps) => {
  const { t } = useTranslation('ui-business');

  return (
    <DropdownMenu defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger asChild>
        <Button variant='outlined' color='primary' size='sm' loading={exporting} className='w-28' startIcon={<Icon name='download' />}>
          {t('data_table.export')}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start'>{children}</DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DataTableExport;
